module.exports = __webpack_public_path__ + "static/media/iClimaLogo.f25a69af.png";